import { render } from "./SampleWells.vue?vue&type=template&id=714783c3&scoped=true"
import script from "./SampleWells.vue?vue&type=script&lang=js"
export * from "./SampleWells.vue?vue&type=script&lang=js"

import "./SampleWells.vue?vue&type=style&index=0&id=714783c3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714783c3"]])

export default __exports__